import isEmptyArray from '../../../general/isEmpty/isEmptyArray';

import * as exOperation from '../operation';

// ----------------------------------------------------------------------------

function data(element: HTMLElement, config: Record<string, any> = {}): void {
    // If using columns or column definitions
    if (!isEmptyArray(config.columns) || !isEmptyArray(config.columnDefs)) {
        // Operation Start
        exOperation.start(element, config);
    }
}

// ----------------------------------------------------------------------------

export { data };
